import styled from 'styled-components';
import { Typography } from '@/components';
import type { Variant } from './EDD';
import EventAvailableIcon from '../../../../public/images/icons/event_available.svg';

export const EDDContainer = styled.div<{ variant: Lowercase<Variant> }>(({ theme, variant }) => ({
  borderTopLeftRadius: 3,
  borderTopRightRadius: 3,
  display: 'flex',
  alignItems: 'flex-start',
  color: variant === 'details' ? theme.colors.highEmphasisWhite : theme.colors.mediumEmphasisBlack,

  ['> :first-child']: {
    marginRight: theme.spacing[4],
  },
}));

export const EDDText = styled(Typography).attrs<{ eddVariant: Lowercase<Variant> }>((props) => ({
  variant: props.eddVariant === 'details' ? 'Heading 5' : 'Caption Text',
}))({
  color: 'inherit',
  display: '-webkit-box',
  textOverflow: 'ellipsis',
  WebkitBoxOrient: 'vertical',
  overflow: 'hidden',
  WebkitLineClamp: 1,
});

export const EDDIcon = styled(EventAvailableIcon)({
  color: 'inherit',
  flexShrink: 0,
});
